import React, { useState, useEffect } from 'react';

export function KaraokeOverlayPreview({
  words = [],
  accent = 'neon', // 'neon' (#7906fb) | 'gold' (#ff9101) | 'white' (#ffffff)
  isPlaying = true
}) {
  const [activeWordIndex, setActiveWordIndex] = useState(0);

  useEffect(() => {
    if (!isPlaying || words.length === 0) return;
    const interval = setInterval(() => {
      setActiveWordIndex((prev) => (prev + 1) % words.length);
    }, 400);
    return () => clearInterval(interval);
  }, [isPlaying, words]);

  const glowColor = accent === 'gold' ? '#ff9101' : accent === 'white' ? '#ffffff' : '#7906fb';
  const glowShadow = accent === 'gold'
    ? '0 0 16px rgba(255, 145, 1, 0.9), 0 0 32px rgba(255, 145, 1, 0.5)'
    : accent === 'white'
    ? '0 0 16px rgba(255, 255, 255, 0.9), 0 0 32px rgba(255, 255, 255, 0.5)'
    : '0 0 18px rgba(121, 6, 251, 0.95), 0 0 36px rgba(121, 6, 251, 0.6)';

  return (
    <div style={{
      position: 'absolute',
      bottom: '34%',
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pointerEvents: 'none',
      zIndex: 28,
      padding: '0 40px'
    }}>
      {/* Scrim sutil inferior */}
      <div style={{
        position: 'absolute',
        bottom: '-112px',
        left: 0,
        right: 0,
        height: '140px',
        background: 'linear-gradient(to top, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0) 100%)',
        zIndex: -1
      }} />

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '90%'
      }}>
        {words.map((w, idx) => {
          const isActive = idx === activeWordIndex;
          const isPast = idx < activeWordIndex;

          return (
            <span
              key={idx}
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 900,
                fontSize: isActive ? '34px' : '30px',
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                transition: 'all 0.15s cubic-bezier(0.2, 0, 0, 1)',
                color: isActive ? '#ffffff' : isPast ? '#ede6d6' : 'rgba(237, 230, 214, 0.45)',
                textShadow: isActive ? glowShadow : '0 2px 8px rgba(0,0,0,0.8)',
                transform: isActive ? 'scale(1.08) translateY(-3px)' : 'scale(1.0)',
                borderBottom: isActive ? `3px solid ${glowColor}` : 'none',
                paddingBottom: isActive ? '2px' : '0'
              }}
            >
              {w.text || w}
            </span>
          );
        })}
      </div>
    </div>
  );
}
